"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokingSlipVersionDetails = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const preferred_insurer_details_entity_1 = require("./preferred-insurer-details.entity");
const preferred_tpa_details_entity_1 = require("./preferred-tpa-details.entity");
const opportunity_broking_slip_version_cover_map_details_entity_1 = require("./opportunity-broking-slip-version-cover-map-details.entity");
const opportunity_quote_entry_entity_1 = require("./opportunity-quote-entry.entity");
let BrokingSlipVersionDetails = class BrokingSlipVersionDetails {
};
exports.BrokingSlipVersionDetails = BrokingSlipVersionDetails;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetails.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetails.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "sum_insured", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetails.prototype, "sumInsured", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "brokerage_percentage", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetails.prototype, "brokeragePercentage", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_from", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], BrokingSlipVersionDetails.prototype, "policyFrom", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_to", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], BrokingSlipVersionDetails.prototype, "policyTo", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "renewal_date", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], BrokingSlipVersionDetails.prototype, "renewalDate", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "quote_receipt_timeline", type: "date", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], BrokingSlipVersionDetails.prototype, "quoteReceiptTimeline", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "business_activity", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetails.prototype, "businessActivity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "risk_mitigation_features", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetails.prototype, "riskMitigationFeatures", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "clauses", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetails.prototype, "clauses", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "insurer_remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetails.prototype, "insurerRemarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "remarks", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetails.prototype, "remarks", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: "created_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], BrokingSlipVersionDetails.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({
        name: "updated_at",
        type: "timestamptz",
        default: () => "CURRENT_TIMESTAMP",
    }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], BrokingSlipVersionDetails.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.DeleteDateColumn)({ name: "deleted_at", type: "timestamptz", nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Date !== "undefined" && Date) === "function" ? _g : Object)
], BrokingSlipVersionDetails.prototype, "deletedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetails.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetails.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "broking_slip_version", type: "numeric", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], BrokingSlipVersionDetails.prototype, "brokingSlipVersion", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "broking_slip_name", type: "text", nullable: true }),
    tslib_1.__metadata("design:type", String)
], BrokingSlipVersionDetails.prototype, "brokingSlipName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", typeof (_h = typeof opportunity_entity_1.Opportunity !== "undefined" && opportunity_entity_1.Opportunity) === "function" ? _h : Object)
], BrokingSlipVersionDetails.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => preferred_insurer_details_entity_1.PreferredInsurerDetails, (insurerDetail) => insurerDetail.brokingSlip),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipVersionDetails.prototype, "preferredInsurerDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => preferred_tpa_details_entity_1.PreferredTpaDetails, (tpaDetail) => tpaDetail.brokingSlip),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipVersionDetails.prototype, "preferredTpaDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_broking_slip_version_cover_map_details_entity_1.BrokingSlipVersionCoverDetails, (coverMapDetail) => coverMapDetail.brokingSlipVersion, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipVersionDetails.prototype, "coverDetails", void 0);
tslib_1.__decorate([
    (0, typeorm_1.OneToMany)(() => opportunity_quote_entry_entity_1.OpportunityQuoteEntry, (quoteEntry) => quoteEntry.brokingSlipVersion, { cascade: true }),
    tslib_1.__metadata("design:type", Array)
], BrokingSlipVersionDetails.prototype, "quoteEntry", void 0);
exports.BrokingSlipVersionDetails = BrokingSlipVersionDetails = tslib_1.__decorate([
    (0, typeorm_1.Entity)({ name: "opportunity_broking_slip_version_details" })
], BrokingSlipVersionDetails);
